import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCircleX"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9 7.58579L7.58579 9L10.5858 12L7.58579 15L9 16.4142L12 13.4142L15 16.4142L16.4142 15L13.4142 12L16.4142 9L15 7.58579L12 10.5858L9 7.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleX;
